export default {
  common: { black: '#000', white: '#fff' },
  background: {
    light: '#F4F6F8',
    lightBlue: '#DDE7F0',
    dark: '#323D59',
    darker: '#061227',
    default: '#fff',
    paper: '#fff',
    error: '#fdf3f5',
    tableBg: '#fbfbfb',
  },
  primary: {
    lightest: '#f3fafb',
    lighter: '#e0fbff',
    light: '#1fbfd6',
    main: '#38C2D6',
    dark: '#008ea5',
    darker: '#148A93',
    contrastText: '#fff',
  },
  secondary: {
    lightest: '#ffe9ed',
    lighter: '#ffd7de',
    light: '#ff718b',
    main: '#EF4766',
    dark: '#b70035',
    darker: '#BA3152',
  },
  error: {
    light: '#e5a0a0',
    main: '#de4c4c',
    dark: '#992c2c',
  },
  warning: {
    lighter: '#fce4b5',
    light: '#f6d287',
    main: '#ffb00c',
    dark: '#b77c01',
  },
  success: {
    lighter: '#b1e8b4',
    light: '#81c784',
    main: '#4caf50',
    dark: '#388e3c',
  },
  divider: '#e4e4e4',
  darkDivider: '#c7c7c7',
  text: {
    primary: '#242f4a',
    secondary: 'rgba(36, 45, 62, 0.7)',
    secondaryLight: '#9ca8b3',
    disabled: '#a0a3a8',
    hint: '#9ca8b3',
    darkHint: '#888888',
    icon: 'rgba(255, 255, 255, 0.5)',
    gray: 'rgba(0, 0, 0, 0.6)',
    disabledLabel: '#b2b2b2',
  },
  ndis: {
    primary: '#6a2376',
    secondary: '#82c53e',
  },
};
